module.exports = __webpack_public_path__ + "static/img/Store-2.9412f042.png";